import { uiFeatureApi } from "@/services/backendApi";
import { isMenuAccessStale, touchMenuAccessLoadedAt } from "@/config/session";

export function hasFeatureAccessConfigured(featureKeys) {
  return Array.isArray(featureKeys) && featureKeys.length > 0;
}

export function canViewFeature(featureKey, featureKeys) {
  if (!featureKey) return true;
  if (!hasFeatureAccessConfigured(featureKeys)) return true;
  return featureKeys.includes(featureKey);
}

export async function loadAndStoreFeatureAccess(store, userId) {
  const uid = userId ?? store.state.user?.userId;
  const keys = await uiFeatureApi.getByUser(uid);
  const list = Array.isArray(keys) ? keys : [];
  store.commit("setFeatureAccess", list);
  touchMenuAccessLoadedAt();
  return list;
}

export async function ensureFeatureAccess(store) {
  const userId = store.state.user?.userId;
  if (!userId) return [];
  const hasRows =
    Array.isArray(store.state.featureAccess) && store.state.featureAccess.length;
  if (hasRows && !isMenuAccessStale()) {
    return store.state.featureAccess;
  }
  return loadAndStoreFeatureAccess(store, userId);
}
